import React, { Component } from "react";
import CSSClasses from "./RegularKeyboard.css";
import { connect } from "react-redux";
import * as StoreActions from "../../../ReduxStore/Actions/ActionIndex";

import beepMedium from "../../../assets/sounds/beep_medium.mp3";

//import imgClose from "../../../assets/images/icons/icon_close.png";

export const KEYBOARD_POSITION_FOR_USERNAME_PASSWORD = 1;
export const KEYBOARD_POSITION_FOR_TICKET_CHECK = 2;
export const KEYBOARD_POSITION_FOR_ADMIN_LOGIN = 3;

let buttonInfo = {
  row1: [
    {
      id: 1,
      label: "1",
      labelShifted: "!",
      value: 1,
      order: 1
    },
    {
      id: 2,
      label: "2",
      labelShifted: '"',
      value: 2,
      order: 2
    },
    {
      id: 3,
      label: "3",
      labelShifted: "#",
      value: 3,
      order: 3
    },
    {
      id: 4,
      label: "4",
      labelShifted: "$",
      value: 4,
      order: 4
    },
    {
      id: 5,
      label: "5",
      labelShifted: "%",
      value: 5,
      order: 5
    },
    {
      id: 6,
      label: "6",
      labelShifted: "&",
      value: 6,
      order: 6
    },
    {
      id: 7,
      label: "7",
      labelShifted: "/",
      value: 7,
      order: 7
    },
    {
      id: 8,
      label: "8",
      labelShifted: "(",
      value: 8,
      order: 8
    },
    {
      id: 9,
      label: "9",
      labelShifted: ")",
      value: 9,
      order: 9
    },
    {
      id: 10,
      label: "0",
      labelShifted: "=",
      value: 0,
      order: 10
    },
    {
      id: 11,
      label: "'",
      labelShifted: "?",
      value: 0,
      order: 10
    },
    {
      id: 12,
      label: "+",
      labelShifted: "*",
      value: 0,
      order: 10
    },
    {
      id: 13,
      label: "⌫",
      labelShifted: "⌫",
      value: "bksp",
      order: 10
    }
  ],
  row2: [
    {
      id: 1,
      label: "q",
      labelShifted: "Q",
      value: 1,
      order: 1
    },
    {
      id: 2,
      label: "w",
      labelShifted: "W",
      value: 2,
      order: 2
    },
    {
      id: 3,
      label: "e",
      labelShifted: "E",
      value: 3,
      order: 3
    },
    {
      id: 4,
      label: "r",
      labelShifted: "R",
      value: 4,
      order: 4
    },
    {
      id: 5,
      label: "t",
      labelShifted: "T",
      value: 5,
      order: 5
    },
    {
      id: 6,
      label: "z",
      labelShifted: "Z",
      value: 6,
      order: 6
    },
    {
      id: 7,
      label: "u",
      labelShifted: "U",
      value: 7,
      order: 7
    },
    {
      id: 8,
      label: "i",
      labelShifted: "I",
      value: 8,
      order: 8
    },
    {
      id: 9,
      label: "o",
      labelShifted: "O",
      value: 9,
      order: 9
    },
    {
      id: 10,
      label: "p",
      labelShifted: "P",
      value: 0,
      order: 10
    },
    {
      id: 11,
      label: "š",
      labelShifted: "Š",
      value: 0,
      order: 10
    },
    {
      id: 12,
      label: "đ",
      labelShifted: "Đ",
      value: 0,
      order: 10
    },
    {
      id: 13,
      label: "@",
      labelShifted: "@",
      value: 0,
      order: 10
    }
  ],
  row3: [
    {
      id: 1,
      label: "a",
      labelShifted: "A",
      value: 1,
      order: 1
    },
    {
      id: 2,
      label: "s",
      labelShifted: "S",
      value: 2,
      order: 2
    },
    {
      id: 3,
      label: "d",
      labelShifted: "D",
      value: 3,
      order: 3
    },
    {
      id: 4,
      label: "f",
      labelShifted: "F",
      value: 4,
      order: 4
    },
    {
      id: 5,
      label: "g",
      labelShifted: "G",
      value: 5,
      order: 5
    },
    {
      id: 6,
      label: "h",
      labelShifted: "H",
      value: 6,
      order: 6
    },
    {
      id: 8,
      label: "j",
      labelShifted: "J",
      value: 8,
      order: 8
    },
    {
      id: 9,
      label: "k",
      labelShifted: "K",
      value: 9,
      order: 9
    },
    {
      id: 10,
      label: "l",
      labelShifted: "L",
      value: 0,
      order: 10
    },
    {
      id: 11,
      label: "č",
      labelShifted: "Č",
      value: 0,
      order: 10
    },
    {
      id: 12,
      label: "ć",
      labelShifted: "Ć",
      value: 0,
      order: 10
    },
    {
      id: 13,
      label: "ž",
      labelShifted: "Ž",
      value: 0,
      order: 10
    }
  ],
  row4: [
    {
      id: 133,
      label: "<",
      labelShifted: ">",
      value: 1,
      order: 1
    },
    {
      id: 1,
      label: "y",
      labelShifted: "Y",
      value: 1,
      order: 1
    },
    {
      id: 2,
      label: "x",
      labelShifted: "X",
      value: 2,
      order: 2
    },
    {
      id: 3,
      label: "c",
      labelShifted: "C",
      value: 3,
      order: 3
    },
    {
      id: 4,
      label: "v",
      labelShifted: "V",
      value: 4,
      order: 4
    },
    {
      id: 5,
      label: "b",
      labelShifted: "B",
      value: 5,
      order: 5
    },
    {
      id: 6,
      label: "n",
      labelShifted: "N",
      value: 6,
      order: 6
    },
    {
      id: 7,
      label: "m",
      labelShifted: "M",
      value: 7,
      order: 7
    },
    {
      id: 8,
      label: ",",
      labelShifted: ";",
      value: 8,
      order: 8
    },
    {
      id: 9,
      label: ".",
      labelShifted: ":",
      value: 9,
      order: 9
    },
    {
      id: 10,
      label: "-",
      labelShifted: "_",
      value: 0,
      order: 10
    },
    {
      id: 11,
      label: "⇧ SHIFT",
      labelShifted: "⇧ SHIFT",
      value: "shift",
      order: 10
    }
  ]
};

class RegularKeyboard extends Component {
  state = {
    isShiftActive: false
  };

  render() {
    let positionClass = "";
    let hasBackgroundOverlay = false;

    switch (this.props.position) {
      case KEYBOARD_POSITION_FOR_TICKET_CHECK:
        positionClass = CSSClasses.positionedForTicketCheck;
        hasBackgroundOverlay = true;
        break;
      case KEYBOARD_POSITION_FOR_USERNAME_PASSWORD:
        positionClass = CSSClasses.positionedForUsernamePassword;
        break;
      case KEYBOARD_POSITION_FOR_ADMIN_LOGIN:
        positionClass = CSSClasses.positionedForAdminLogin;
        break;
      default:
        break;
    }

    return (
      <div>
        {hasBackgroundOverlay ? (
          <div className={CSSClasses.backgroundOverlay}>&nbsp;</div>
        ) : null}

        <audio
          ref={sound => {
            this.beepMedium = sound;
          }}
        >
          <source src={beepMedium} type="audio/mpeg" />
        </audio>

        <div className={[CSSClasses.container, positionClass].join(" ")}>
          <div
            className={CSSClasses.btnClose}
            onClick={() => {
              //daj zvukic
              if (this.beepMedium) {
                //daj zvukic
                this.beepMedium.play();
              }
              this.props.closeHandler();
            }}
          >
            X
          </div>

          <div style={{ clear: "both" }}>
            {buttonInfo.row1.map(btn => {
              return (
                <div
                  key={btn.id}
                  className={CSSClasses.buttonBox}
                  onClick={() => {
                    this.keyboardButton_Click(btn);
                  }}
                >
                  {this.state.isShiftActive ? btn.labelShifted : btn.label}
                </div>
              );
            })}

            <div className={CSSClasses.clearFix} />

            {buttonInfo.row2.map(btn => {
              return (
                <div
                  key={btn.id}
                  className={CSSClasses.buttonBox}
                  onClick={() => {
                    this.keyboardButton_Click(btn);
                  }}
                >
                  {this.state.isShiftActive ? btn.labelShifted : btn.label}
                </div>
              );
            })}
            <div className={CSSClasses.clearFix} />
            {buttonInfo.row3.map(btn => {
              return (
                <div
                  key={btn.id}
                  className={CSSClasses.buttonBox}
                  onClick={() => {
                    this.keyboardButton_Click(btn);
                  }}
                >
                  {this.state.isShiftActive ? btn.labelShifted : btn.label}
                </div>
              );
            })}
            <div className={CSSClasses.clearFix} />
            {buttonInfo.row4.map(btn => {
              return (
                <div
                  key={btn.id}
                  className={[
                    CSSClasses.buttonBox,
                    btn.value === "shift" && this.state.isShiftActive
                      ? CSSClasses.activeShift
                      : ""
                  ].join(" ")}
                  onClick={() => {
                    this.keyboardButton_Click(btn);
                  }}
                >
                  {this.state.isShiftActive ? btn.labelShifted : btn.label}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  keyboardButton_Click = key => {
    console.log("CLICK! ", key);

    //daj zvukic
    if (this.beepMedium) {
      //daj zvukic
      this.beepMedium.play();
    }

    let oldAmount = "";

    //dohvati stari bet amount
    // let oldAmount = props.betAmount.toString();

    // if (value === -2) {
    //   //delete!
    //   props.updateBetAmount(0);
    //   return;
    // }

    // if (props.betAmount === 0) {
    //   oldAmount = "";
    // }

    if (key.value === -1) {
      //decimala, ako vec ima ili je prazno, ignore
      if (oldAmount === "" || oldAmount.indexOf(".") !== -1) {
        //ignore
        console.log("DOT RETURN");
        return;
      }
      console.log("DOT ADD");
      oldAmount += ".00";
    } else {
      oldAmount += key.value;
    }

    if (key.value === "shift") {
      this.setState({ isShiftActive: !this.state.isShiftActive });
      console.log("UPDATING SHIFT");
    }

    this.props.keyDownHandler(key, this.state.isShiftActive);

    //let newAmount = parseFloat(oldAmount);
    //props.updateBetAmount(newAmount);
  };
}

const mapStateToProps = state => {
  return {
    isShowingNumericKeyboard: state.rrAppState.isShowingNumericKeyboard,
    betAmount: state.rrTicket.betAmount
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeNumericKeyboardVisibility: isShown =>
      dispatch(StoreActions.SetNumericKeyboardVisibility(isShown)),
    updateBetAmount: newAmount => dispatch(StoreActions.SetBetAmount(newAmount))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegularKeyboard);



// WEBPACK FOOTER //
// ./src/Components/Keyboards/RegularKeyboard/RegularKeyboard.js